import { Panel } from "../../components/Panel/Panel.jsx";
import { DashboardPage, createDashboardLayout } from "../../components/DashboardPage/DashboardPage.jsx";
import { ShortcutReference } from "../../components/ShortcutReference/ShortcutReference.jsx";
import { APP_LANGUAGE_HEBREW } from "../../lib/settings/appSettings.js";
import { HelpShortcutsIntroContent as HelpShortcutsIntroContentEn } from "../../i18n/content/en/HelpShortcutsIntroContent.jsx";
import { HelpShortcutsIntroContent as HelpShortcutsIntroContentHe } from "../../i18n/content/he/HelpShortcutsIntroContent.jsx";
import "./help-ui.css";
import "./HelpShortcutsPane.css";

function createHelpShortcutGroups(t = (key) => key) {
  return [
    {
      key: "global",
      label: t("help.shortcuts.groups.global"),
      shortcuts: [
        {
          id: "select-tab",
          keys: ["Alt", "+", "1", "/", "2", "/", "3", "/", "4", "/", "5", "/", "6"],
          label: t("help.shortcuts.shortcuts.selectTab.label"),
          note: t("help.shortcuts.shortcuts.selectTab.note")
        },
        {
          id: "context-actions",
          keys: [{ kind: "literal", value: "/" }],
          label: t("help.shortcuts.shortcuts.contextActions.label"),
          note: t("help.shortcuts.shortcuts.contextActions.note")
        },
        {
          id: "escape-reset",
          keys: ["Esc"],
          label: t("help.shortcuts.shortcuts.escapeReset.label"),
          note: t("help.shortcuts.shortcuts.escapeReset.note")
        },
        {
          id: "focus-search",
          keys: ["Alt", "+", "Q"],
          label: t("help.shortcuts.shortcuts.focusSearch.label"),
          note: t("help.shortcuts.shortcuts.focusSearch.note")
        },
        {
          id: "focus-main-control",
          keys: ["Alt", "+", "E"],
          label: t("help.shortcuts.shortcuts.focusMainControl.label"),
          note: t("help.shortcuts.shortcuts.focusMainControl.note")
        },
        {
          id: "focus-sidebar",
          keys: ["Alt", "+", "S"],
          label: t("help.shortcuts.shortcuts.focusSidebar.label"),
          note: t("help.shortcuts.shortcuts.focusSidebar.note")
        },
        {
          id: "focus-work-area",
          keys: ["Alt", "+", "W"],
          label: t("help.shortcuts.shortcuts.focusWorkArea.label"),
          note: t("help.shortcuts.shortcuts.focusWorkArea.note")
        },
        {
          id: "navigate-sidebar-sections",
          keys: ["Alt", "+", { kind: "icon", name: "up" }, "/", "Alt", "+", { kind: "icon", name: "down" }],
          label: t("help.shortcuts.shortcuts.navigateSidebarSections.label"),
          note: t("help.shortcuts.shortcuts.navigateSidebarSections.note")
        },
        {
          id: "navigate-page-sections",
          keys: ["Alt", "+", "PgUp", "/", "Alt", "+", "PgDn"],
          label: t("help.shortcuts.shortcuts.navigatePageSections.label"),
          note: t("help.shortcuts.shortcuts.navigatePageSections.note")
        },
        {
          id: "next-year",
          keys: ["Alt", "+", "Y"],
          label: t("help.shortcuts.shortcuts.nextYear.label"),
          note: t("help.shortcuts.shortcuts.nextYear.note")
        },
        {
          id: "switch-language",
          keys: ["Alt", "+", "L"],
          label: t("help.shortcuts.shortcuts.switchLanguage.label"),
          note: t("help.shortcuts.shortcuts.switchLanguage.note")
        },
        {
          id: "cycle-theme",
          keys: ["Alt", "+", "P"],
          label: t("help.shortcuts.shortcuts.cycleTheme.label"),
          note: t("help.shortcuts.shortcuts.cycleTheme.note")
        }
      ]
    },
    {
      key: "homepage",
      label: t("help.shortcuts.groups.homepage"),
      shortcuts: [
        {
          id: "home-move-card",
          keys: [{ kind: "icon", name: "up" }, "/", { kind: "icon", name: "down" }, "/", { kind: "icon", name: "left" }, "/", { kind: "icon", name: "right" }],
          label: t("help.shortcuts.shortcuts.homeMoveCard.label"),
          note: t("help.shortcuts.shortcuts.homeMoveCard.note")
        },
        {
          id: "home-edit-card",
          keys: ["Space"],
          label: t("help.shortcuts.shortcuts.homeEditCard.label"),
          note: t("help.shortcuts.shortcuts.homeEditCard.note")
        },
        {
          id: "home-open-card",
          keys: ["Enter"],
          label: t("help.shortcuts.shortcuts.homeOpenCard.label"),
          note: t("help.shortcuts.shortcuts.homeOpenCard.note")
        },
        {
          id: "home-cancel-edit",
          keys: ["Esc"],
          label: t("help.shortcuts.shortcuts.homeCancelEdit.label")
        }
      ]
    },
    {
      key: "expenses",
      label: t("help.shortcuts.groups.expenses"),
      shortcuts: [
        {
          id: "show-all-hidden",
          keys: ["Alt", "+", "A"],
          label: t("help.shortcuts.shortcuts.showAllHidden.label"),
          note: t("help.shortcuts.shortcuts.showAllHidden.note")
        }
      ]
    },
    {
      key: "tables",
      label: t("help.shortcuts.groups.tables"),
      shortcuts: [
        {
          id: "move-cell",
          keys: [{ kind: "icon", name: "up" }, "/", { kind: "icon", name: "down" }, "/", { kind: "icon", name: "left" }, "/", { kind: "icon", name: "right" }],
          label: t("help.shortcuts.shortcuts.moveCell.label")
        },
        {
          id: "jump-edge",
          keys: ["Ctrl", "+", { kind: "icon", name: "up" }, "/", { kind: "icon", name: "down" }, "/", { kind: "icon", name: "left" }, "/", { kind: "icon", name: "right" }],
          label: t("help.shortcuts.shortcuts.jumpEdge.label")
        },
        {
          id: "edit-cell",
          keys: ["Enter"],
          label: t("help.shortcuts.shortcuts.editCell.label")
        },
        {
          id: "tab-move-cell",
          keys: ["Tab", "/", "Shift", "+", "Tab"],
          label: t("help.shortcuts.shortcuts.tabMoveCell.label")
        },
        {
          id: "new-row",
          keys: ["Alt", "+", "N"],
          label: t("help.shortcuts.shortcuts.newRow.label"),
          note: t("help.shortcuts.shortcuts.newRow.note")
        },
        {
          id: "duplicate-row",
          keys: ["Alt", "+", "C"],
          label: t("help.shortcuts.shortcuts.duplicateRow.label"),
          note: t("help.shortcuts.shortcuts.duplicateRow.note")
        },
        {
          id: "delete-row",
          keys: ["Ctrl", "+", "Del"],
          label: t("help.shortcuts.shortcuts.deleteRow.label"),
          note: t("help.shortcuts.shortcuts.deleteRow.note")
        }
      ]
    },
    {
      key: "explorer",
      label: t("help.shortcuts.groups.explorer"),
      shortcuts: [
        {
          id: "navigate-rows",
          keys: [{ kind: "icon", name: "up" }, "/", { kind: "icon", name: "down" }],
          label: t("help.shortcuts.shortcuts.navigateRows.label")
        },
        {
          id: "expand-branch",
          keys: [{ kind: "icon", name: "right" }],
          label: t("help.shortcuts.shortcuts.expandBranch.label")
        },
        {
          id: "collapse-branch",
          keys: [{ kind: "icon", name: "left" }],
          label: t("help.shortcuts.shortcuts.collapseBranch.label")
        },
        {
          id: "toggle-branch",
          keys: ["Space", "/", "Enter"],
          label: t("help.shortcuts.shortcuts.toggleBranch.label")
        }
      ]
    },
    {
      key: "development",
      label: t("help.shortcuts.groups.development"),
      shortcuts: [
        {
          id: "open-dev",
          keys: ["Alt", "+", "F12"],
          label: t("help.shortcuts.shortcuts.openDev.label"),
          note: t("help.shortcuts.shortcuts.openDev.note")
        }
      ]
    }
  ];
}

const helpShortcutsLayout = createDashboardLayout({
  columns: [
    "minmax(0, 1.7fr)",
    "minmax(18rem, 0.85fr)"
  ],
  rows: [
    { size: "fill" }
  ],
  areas: [
    ["reference", "intro"]
  ]
});

export function HelpShortcutsPane({ t = (key) => key, activeLanguage }) {
  const helpShortcutGroups = createHelpShortcutGroups(t);
  const HelpShortcutsIntroContent = activeLanguage === APP_LANGUAGE_HEBREW
    ? HelpShortcutsIntroContentHe
    : HelpShortcutsIntroContentEn;

  return (
    <DashboardPage
      layout={helpShortcutsLayout}
      slots={[
        {
          key: "reference",
          area: "reference",
          content: (
            <Panel
              className="help-shortcuts-reference"
              header={t("reference")}
            >
              <ShortcutReference groups={helpShortcutGroups} embedded />
            </Panel>
          )
        },
        {
          key: "intro",
          area: "intro",
          fill: false,
          content: (
            <Panel
              padded
              className="help-shortcuts-intro"
              header={t("shortcuts")}
            >
              <HelpShortcutsIntroContent />
            </Panel>
          )
        }
      ]}
    />
  );
}
